import styled from "styled-components";

export const Container = styled.section`
  background-color: #e5d8cb;
  padding: 60px 40px;
  display: flex;
  justify-content: center;

  @media (max-width: 768px) {
    padding: 48px 20px;
  }
`;

export const CardsWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  max-width: 1100px;
  width: 100%;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
    max-width: 480px;
  }
`;

export const Card = styled.div`
  background: #ffffff;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  cursor: pointer;
  text-decoration: none;
  color: inherit;
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 28px rgba(0, 0, 0, 0.14);
  }
`;

export const CardImage = styled.img`
  width: 100%;
  height: 200px;
  object-fit: cover;

  @media (max-width: 900px) {
    height: 220px;
  }
`;

export const CardBody = styled.div`
  padding: 10px 14px 12px;
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const CardTitle = styled.h3`
  font-family: 'Poppins', sans-serif;
  font-size: 22px;
  font-weight: 700;
  color: #000000;
  margin: 0 0 6px 0;
`;

export const CardText = styled.p`
  font-family: 'Aileron', sans-serif;
  font-size: 13px;
  font-weight: 400;
  color: #444444;
  margin: 0;
  line-height: 1.6;
`;

export const AppCardContent = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 14px;
`;

export const AppIcon = styled.img`
  width: 72px;
  height: 72px;
  border-radius: 16px;
  object-fit: cover;
  flex-shrink: 0;
`;

export const AppMockup = styled.img`
  height: 120px;
  width: auto;
  object-fit: contain;
`;
